import React, { useEffect, useState } from "react";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import Input from "../../Components/Input/Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Resizer from "react-image-file-resizer";
import Style from "./EditDetailProduct.module.css";
import { faImage, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import {
  PostExistFood,
  getCategoryDiscountApi,
  getImagesAPi,
  removeImageApi,
} from "../../Api/BarestSupplierServices";
import LoadingComponent from "../../Components/LoadingComponet/LoadingComponet";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";
const EditDetailProduct = (props) => {
  const [price, setPrice] = useState("");
  const [detail, setDetail] = useState("");
  const [name, setName] = useState("");
  const [category, setCategory] = useState([]);
  const [categorySelected, setCategorySelected] = useState("");
  const [files, setFiles] = useState([]);
  const [loading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [count, setCount] = useState("");
  const [packed, setPacked] = useState(false);
  const [imgs, setImgs] = useState([]);
  let history = useHistory()
  useEffect(() => {
    getCategoryFood();
    getImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //////گرفتن عکس های قبلی محصول
  const getImages = async () => {
    const result = await getImagesAPi(props.location.state.pId.id);
    setImgs(result.product.img);
    setDetail(result.product.other_detail);
    setPrice(result.product.price);
    setName(result.product.name);
    setCategorySelected(result.product.category_free_id);
    setCount(result.product.count)
  };
  ////////////حذف عکس
  const removeImage = (name) => {
    const info = {
      product_id: props.location.state.pId.id,
      file: name,
    };
    removeImageApi(info, (res) => {
      getImages();
    });
  };

  /////////اپلود عکس ها

  const UploadImage = async (images) => {
    return await resizeFile(images);
  };

  const resizeFile = (file) => {
    for (let i = 0; i < file.length; i++) {
      Resizer.imageFileResizer(
        file[i],
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setFiles((prevfiles) => [...prevfiles, uri]);
        },
        "base64"
      );
    }
  };

  ///////گرفتن دسته بندی
  const getCategoryFood = async () => {
    const result = await getCategoryDiscountApi();
    setCategory(result.category);
  };

  const removeUploadImage = (name) => {
    setFiles((oldState) => oldState.filter((item) => item !== name));
  };
  ////////پست کردن اطلاعات ویرایش شده
  const sendUpdateData = () => {
    setLoadingBtn(true);
    let info = {
      product_id: props.location.state.pId.id,
      price: price,
      category_free_id: categorySelected,
      other_detail: detail,
      name: name,
      file: files,
      count:count,
      packed:packed?0:-1,
      off_price:0
    };
    console.log(info)
    PostExistFood(info, (res) => {
      if (res.status === 1) {
        setLoadingBtn(false);
        succToast(res.message);
        setTimeout(() => {
          history.goBack();
        }, 500);
      } else {
        setLoadingBtn(false);
        errorToast(res.message);
      }
    });
    getImages();
  };
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  console.log(count)
  return (
    <div className={Style.pageHolder}>
      {loading ? <LoadingComponent /> : null}
      <MenuTitle title={"ویرایش و جزئیات محصول"} />
      <section className={Style.centerHolder}>
        <div className={Style.imagePart}>
          {imgs.map((item, index) => {
            return (
              <div key={index} className={Style.eachImage}>
                <div className={Style.picHolder}>
                  <img
                    src={`https://cdn.barest.ir/product/m/${item}.jpg?${randomNumberInRange(
                      1,
                      1000000000000
                    )}`}
                    alt=""
                  />
                </div>
                <div
                  className={Style.iconHolder}
                  onClick={() => removeImage(item)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              </div>
            );
          })}
          {files.map((item, index) => {
            return (
              <div key={index} className={Style.eachImage}>
                <div className={Style.picHolder}>
                  <img src={item} alt="" />
                </div>
                <div
                  className={Style.iconHolder}
                  onClick={() => removeUploadImage(item)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              </div>
            );
          })}
        </div>
        <div className={Style.inputPart}>
          <div className={Style.fileInput}>
            <label htmlFor="file" className={Style.iconHolderImage}>
              <FontAwesomeIcon icon={faImage} className={Style.imageIcon} />
            </label>
            <h3 className={Style.textfile}>بارگذاری تصویر</h3>
          </div>
          <Input
            id="file"
            type="file"
            inputtype={"file"}
            accept="image/*"
            onChange={(e) => UploadImage(e.target.files)}
            multiple
          />
          <Input
            placeholder={"نام محصول"}
            style={{ marginTop: "1rem", padding: ".6rem" }}
            inputtype={"text"}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <select
            className={Style.category}
            onChange={(e) => setCategorySelected(e.target.value)}
            value={categorySelected}
          >
            {category.map((item) => (
              <option key={item.id} value={item.id}>
                {item.category}
              </option>
            ))}
          </select>
          <label className={Style.packedPart}>
            {" "}
            جزو محصولات بسته بندی شده است
            <input
              onChange={(e) => setPacked(e.target.checked)}
              className={Style.checkedPacked}
              type="checkbox"
            />
          </label>
          <select
            name=""
            id=""
            onChange={(e)=>setCount(e.target.value)}
            value={count}
            className={Style.fileInputPart2}
          >
            <option value="1">موجود</option>
            <option value="0">ناموجود</option>
          </select>
          <Input
            placeholder={"توضیحات تکمیلی"}
            style={{ marginTop: "1rem", padding: ".6rem" }}
            inputtype={"textArea"}
            value={detail}
            onChange={(e) => setDetail(e.target.value)}
          />

          <Input
            placeholder={"قیمت محصول به تومان"}
            style={{ padding: ".6rem" }}
            inputtype={"text"}
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div>
        <div className={Style.btnHolder}>
          <button
            className={Style.addBtn}
            disabled={loadingBtn}
            onClick={sendUpdateData}
          >
            {loadingBtn ? (
              <span style={{ fontSize: ".6rem", direction: "ltr" }}>
                ...لطفا صبر کنید
              </span>
            ) : (
              " افزودن"
            )}
          </button>
        </div>
      </section>
    </div>
  );
};

export default EditDetailProduct;
